var exports = {
  "kL": "TextualAttachmentPreviewBottomSheet.module__container___YWFmb2",
  "Hy": "TextualAttachmentPreviewBottomSheet.module__codeContainer___YWFmb2",
  "Dy": "TextualAttachmentPreviewBottomSheet.module__codeSurface___YWFmb2",
  "qr": "TextualAttachmentPreviewBottomSheet.module__footer___YWFmb2",
  "qt": "TextualAttachmentPreviewBottomSheet.module__fileSection___YWFmb2",
  "gM": "TextualAttachmentPreviewBottomSheet.module__fileMeta___YWFmb2",
  "Md": "TextualAttachmentPreviewBottomSheet.module__fileName___YWFmb2",
  "Ov": "TextualAttachmentPreviewBottomSheet.module__fileSize___YWFmb2",
  "zt": "TextualAttachmentPreviewBottomSheet.module__footerActions___YWFmb2",
  "hP": "TextualAttachmentPreviewBottomSheet.module__actionButton___YWFmb2" + " " + __webpack_require__(377561)["AS"],
};

module.exports = exports;
